<section class="verificar">
  <img src="assets/images/verify-safe-2.png" width="200" alt="seguranca">

  <div class="verificar__title">Verificação de Segurança</div>

  <p>Você já deve ter recebido um <strong>Código de Segurança Omni por SMS ou e-mail</strong>. Agora vamos precisar que você nos confirme esse código.</p>

  <p>Ao inserir o código de segurança, <strong>concordo</strong> com os Termos e Condições anexos e confirmo ser este meu celular/e-mail pessoal, podendo ser, por este meio, contatado para qualquer fim.</p>
</section>